import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const Counter = ({
  end,
  start,
  timeout,
  step,
  onEnd,
}) => {
  // initialize timeLeft with the from prop
  const [timeLeft, setTimeLeft] = useState(start);
  const direction = () => {
    if (end < start) {
      return 'decrease';
    }
    return 'increase';
  };

  useEffect(() => {
    let intervalId = null;

    const dir = direction();
    if (
      (dir === 'decrease' && timeLeft <= end)
      || (dir === 'increase' && timeLeft >= end)
    ) {
      onEnd();
      return clearInterval(intervalId);
    }

    // save intervalId to clear the interval when the
    // component re-renders
    intervalId = setInterval(() => {
      if (dir === 'decrease') {
        setTimeLeft(timeLeft - step);
      } else { setTimeLeft(timeLeft + step); }
    }, timeout);

    // clear interval on re-render to avoid memory leaks
    return () => {
      clearInterval(intervalId);
    };
  }, [timeLeft, start, end]);

  return (
    <span>{timeLeft}</span>
  );
};

Counter.propTypes = {
  end: PropTypes.number,
  start: PropTypes.number,
  timeout: PropTypes.number,
  step: PropTypes.number,
  onEnd: PropTypes.func,
};

Counter.defaultProps = {
  end: 0,
  start: 60,
  timeout: 1000,
  step: 1,
  onEnd: (() => { }),
};

export default Counter;
